export interface SidebarButtonProps {
  label: string
  subLabel?: string
  quantity?: number
  secondQuantity?: number
  secondLabel?: string
  selected: boolean
  onClick: () => void
  icon: string
  sidebarOpen: boolean
  dataTestid: string
}

export const SidebarButton = ({
  label,
  subLabel,
  quantity,
  secondQuantity,
  secondLabel,
  selected,
  onClick,
  icon,
  sidebarOpen,
  dataTestid,
}: SidebarButtonProps): JSX.Element => {
  sidebarOpen
  return (
    <>
      <div
        className={`sidebar-button-container ${selected ? 'selected' : ''}`}
        onClick={onClick}
        data-testid={dataTestid}
      >
        {sidebarOpen ? (
          <>
            <div className="d-flex flex-column">
              <h6 className="sidebar-button-title">
                <strong>{label}</strong>
              </h6>
              <span className="ps-2">
                {quantity} {subLabel}
              </span>
              {secondLabel && (
                <span className="ps-2">
                  ({secondQuantity} {secondLabel})
                </span>
              )}
            </div>
            <i className={`d-flex align-items-end ${icon}`}></i>
          </>
        ) : (
          <i className={`d-flex align-items-end ${icon}`}></i>
        )}
      </div>
    </>
  )
}
